import { render, staticRenderFns } from "./App.vue?vue&type=template&id=718bcffb&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=718bcffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bcffb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718bcffb')) {
      api.createRecord('718bcffb', component.options)
    } else {
      api.reload('718bcffb', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=718bcffb&scoped=true&", function () {
      api.rerender('718bcffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/App.vue"
export default component.exports